import React, { createContext, useContext, useEffect, useState } from "react";
import { useAlert } from "../alertProvider.tsx";
import { StatusCode } from "../../components/Alert.tsx";
import { useNavigate } from "react-router-dom";
import JournalNameController from "../../controllers/JournalNameController.ts";
import { JournalName } from "../../models/JournalName.ts";
import { useUsersContext } from "../users.tsx";

type JournalNamesContextType = {
    isLoaded?: boolean;
    journalNames: JournalName[];
    totalCount: number;
    updateJournalNames: (journalNames: JournalName[]) => void;
}

const JournalNamesContext = createContext<JournalNamesContextType>({} as JournalNamesContextType);

export const JournalNamesContextProvider = ({ children }: { children: any }) => {
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [journalNames, setJournalNames] = useState<JournalName[]>([]);
    const [totalCount, setTotalCount] = useState<number>(0);
    const { showAlert } = useAlert();
    const navigate = useNavigate();
    const usersContext = useUsersContext();

    const fetchJournalNames = async () => {
        try {
            setIsLoaded(false);
            const result = await JournalNameController.get();
            setJournalNames(result.journalNames);
            usersContext.setJournalNames(result.journalNames);
            setTotalCount(result.journalNames.length);
        } catch (error) {
            console.error("Error fetching journal names:", error);
        } finally {
            setIsLoaded(true);
        }
    }
    useEffect(() => {
        fetchJournalNames();
    }, []);

    const updateJournalNames = async (entities: JournalName[]) => {
        try {
            const result = await JournalNameController.put(entities);
            if (result.notificationStatus == StatusCode.success)
            {
                usersContext.setJournalNames(result.journalNames);
                navigate(-1);
            }
            else
                showAlert(result.notificationStatus, result.notificationMessage);
        } catch (error) {
            console.error('Error updating journal names:', error);
        }
    }

    const context: JournalNamesContextType = {
        isLoaded,
        journalNames,
        totalCount,
        updateJournalNames
    }

    return (
        <JournalNamesContext.Provider value={context}>
            {children}
        </JournalNamesContext.Provider>
    )
}

export const useJournalNamesContext = () => useContext(JournalNamesContext);